import React, { useState, useCallback, useRef, useEffect } from 'react';
import axios from 'axios';
import { FaTimes } from 'react-icons/fa';

const products = [
  {
    category: 'Loans',
    items: [
      {
        id: 1,
        title: 'Biashara Loan',
        description: 'Fast and flexible loans secured against your vehicle’s logbook.',
        details: 'Get the funding you need for your business with flexible repayment plans for up to 24 months. Fast, simple, and built for your success.',

        benefits: [
          'Quick approval (4 hours)',
          'Competitive interest rates (4% per Month)',
          'Flexible repayment plans',
        ],
        requirements: [
          'National ID',
          'KRA Pin',
          'Certified 6 Months Bank/Mpesa statements',
          'Original logbook',
          'Insurance cover',
          'Business Documents',
        ],
        image: '/assets/images/loans/logbook.jpg',
      },
      
      {
        id: 2,
        title: 'Asset Financing',
        description: 'Finance your business assets with tailored repayment plans.',
        details: 'Owning your dream car is no longer just a "someday" goal. Its a 36-month plan away. With 80% financing, you can keep your capital working for you while you enjoy the drive.',
        benefits: [
          'Quick approval (4 hours)',
          'Flexible repayment terms',
        ],
        requirements: [
          'Proforma invoice',
          'Original logbook',
          'ID and KRA PIN copy',
          'Certified 6 months Bank/Mpesa Statements',
        ],
        image: '/assets/images/loans/asset-financing.jpg',
      },
      {
        id: 3,
        title: 'Top-Up Loans',
        description: 'Additional borrowing for existing clients over their main loan.',
        details: 'Top-up loans allow existing clients who have serviced their loans for at least 6 months to borrow additional funds.',
        benefits: [
          'Quick approval (4 hours)',
          'Flexible repayment terms',
          'Competitive interest rates (4% per Month)',
        ],
        requirements: [
          'Existing client with TGL Credit Limited',
          'Loan serviced for at least 6 months',
          'Good repayment history',
        ],
        image: '/assets/images/loans/top-up-loans.jpg',
      },
      {
        id: 14,
        title: 'Personal Loans',
        description: 'Quick and easy personal loans for your immediate needs.',
        details: 'Cover personal expenses like medical bills, education, or emergencies. Get up to 3 Million in 4 hours with up to 24 month repayment plans.',

        benefits: [
          'Quick approval (4 hours)',
          'Competitive interest rates (4% per Month)',
          'Flexible repayment plans',

        ],
        requirements: [
          'National ID',
          'KRA Pin',
          'Proof of income',
          'Certified 6 months Bank/Mpesa Statements',
          'Original Logbook',
        ],
        image: '/assets/images/loans/personal-loans.jpg',
      },
      {
        id: 15,
        title: 'LPO Financing',
        description: 'Finance your purchase orders to fulfill contracts seamlessly.',
        details: 'Get funding to execute Local Purchase Orders (LPOs) for government or corporate contracts. Up to 80% financing of the LPO value with repayment aligned to contract payments.',
        benefits: [
          'Fast approval within 4 hours',
          'Flexible repayment based on contract terms',
          'Supports business scalability',
        ],
        requirements: [
          'Valid LPO from a reputable organization',
          'Business registration documents',
          'National ID and KRA Pin',
          'Certified 6 months Bank/Mpesa Statements',
          'Original Logbook',
        ],
        image: '/assets/images/loans/lpo-financing.jpg',
      },
    ],
  },
  {
    category: 'Trade Finance',
    items: [
      {
        id: 5,
        title: 'Unsecured Bid Bonds',
        description: 'Support your business bids without tying up capital.',
        details: 'TGL Credit, through partnerships with reputable banks and insurance companies in Kenya, issues unsecured cash-free bid bonds of up to 20 million to enable tendering firms to obtain guarantees under flexible terms.',
        benefits: [
          'Cash-free',
          'No account opening required',
          'Personalized service with free delivery within CBD',
          'Simple, convenient, and flexible',
          'Cross-border bid bonds for tenders outside Kenya',
          'Multiple institutions to choose from',
        ],
        requirements: [
          'Business registration documents',
          'National ID and KRA Pin',
          'Tender documents',
        ],
        image: '/assets/images/trade/unsecured_bid_bonds.jpg',
      },
      {
        id: 6,
        title: 'Performance Bonds',
        description: 'Guarantee project completion with our performance bonds.',
        details: 'Get genuine performance bonds processed within 1 hour with just 10% refundable cash cover from reputable banks and insurance companies. Unsecured performance bonds up to 3 million with zero cash cover.',
        benefits: [
          'Competitive rates',
          'No account opening required',
          'Multiple institutions to choose from',
        ],
        requirements: [
          'Contract award documents',
          'Business registration documents',
          'National ID and KRA Pin',
        ],
        image: '/assets/images/trade/perfomance.jpg',
      },
      {
        id: 7,
        title: 'Advance Payment Guarantees',
        description: 'Secure advance payments with our guarantees.',
        details: 'We bridge the gap between your contract award and project commencement. Access up to 100% of the Contract Amount with our flexible Advance Payment Guarantees..',
        benefits: [
          
          'Quick access to funds',
          'Flexible terms',
          'Trusted bank partnerships',
        ],
        requirements: [
          'Award letter',
          'Cert of incorporation',
          'Company pin',
		  'Current CR12',
          'Directors IDs and pins',
		  'Company profile',
        ],
        image: '/assets/images/trade/advanced.jpg',
      },
      {
        id: 8,
        title: 'Bank Guarantees',
        description: 'Reliable guarantees for your financial obligations.',
        details: 'A bank guarantee ensures payment to a beneficiary if contract obligations are not met. TGL Credit offers fast and reliable bank guarantee services to reduce financial risk.',
        benefits: [
          'Fast processing',
          'Reduces financial risk',
          'Trusted bank partnerships',
        ],
        requirements: [
          'Contract documents',
          'Business registration documents',
          'National ID and KRA Pin',
        ],
        image: '/assets/images/trade/bank_guarantee.jpg',
      },
      {
        id: 16,
        title: 'Custom Bonds',
        description: 'Avoid demurrages on duty-exempted items with custom bonds.',
        details: 'TGL Credit, through its insurance agency, partners with insurance companies to issue custom bonds, preventing demurrages on duty-exempted items.',
        benefits: [
          'Avoid costly demurrages',
          'Fast issuance',
          'Trusted insurance partnerships',
        ],
        requirements: [
          'Import documents',
          'Business registration documents',
          'National ID and KRA Pin',
        ],
        image: '/assets/images/trade/custom_bonds.jpg',
      },
      {
        id: 17,
        title: 'Retention Bonds',
        description: 'Unlock withheld contract payments with retention bonds.',
        details: 'Access funds withheld for the “Defects Liability Period” to improve cash flow for other projects, avoiding the need for additional loans.',
        benefits: [
          'Improves cash flow',
          'No additional loans needed',
          'Trusted bank partnerships',
        ],
        requirements: [
          'Contract documents',
          'Business registration documents',
          'National ID and KRA Pin',
        ],
        image: '/assets/images/trade/retention_bond.jpg',
      },
    ],
  },
  {
    category: 'Insurance Services',
    items: [
      {
        id: 9,
        title: 'Contractor’s All Risk (CAR)',
        description: 'Comprehensive insurance for construction projects.',
        details: 'This policy provides “ALL RISKS” cover for contractors, protecting against destruction or damage.',
        benefits: [
          'Covers contract works',
          'Includes plant and machinery',
          'Third-party liability coverage',
        ],
        requirements: [
          'Project contract documents',
          'Business registration documents',
          'National ID and KRA Pin',
        ],
        image: '/assets/images/insurance/contractors-all-risk.jpg',
      },
      {
        id: 10,
        title: 'Work Injury Benefits Act (WIBA)',
        description: 'Mandatory coverage for workplace injuries.',
        details: 'Guarantees financial compensation for employees injured, disabled, or deceased while at work, as required by law.',
        benefits: [
          'Covers workplace injuries',
          'Meets legal requirements',
          'Protects employees and employers',
        ],
        requirements: [
          'Business registration documents',
          'Employee records',
          'National ID and KRA Pin',
        ],
        image: '/assets/images/insurance/wiba.jpg',
      },
      {
        id: 11,
        title: 'Professional Indemnity',
        description: 'Protection for professional service providers.',
        details: 'Protects against legal costs and losses from claims of negligent acts, errors, or omissions in professional duties.',
        benefits: [
          'Covers legal costs',
          'Protects against negligence claims',
          'Supports professional credibility',
        ],
        requirements: [
          'Business registration documents',
          'Professional license (if applicable)',
          'National ID and KRA Pin',
        ],
        image: '/assets/images/insurance/indemnity.jpg',
      },
      {
        id: 12,
        title: 'Motor Insurance',
        description: 'Comprehensive coverage for your vehicle with competitive rates.',
        details: 'Covers financial loss from accidents, fire, or theft. Options include Third Party, Third Party Fire & Theft, and Comprehensive coverage.',
        benefits: [
          'Covers accidents, theft, and fire',
          'Competitive rates',
          'Flexible coverage options',
        ],
        requirements: [
          'Vehicle registration documents',
          'National ID and KRA Pin',
          'Driver’s license',
        ],
        image: '/assets/images/insurance/motorinsurance.jpg',
      },
      {
        id: 18,
        title: 'Medical Insurance',
        description: 'Protect against high medical costs with tailored coverage.',
        details: 'Covers hospitalization and high medical costs due to illness or accidents, including in-patient and outpatient treatment, with optional optical and dental coverage.',
        benefits: [
          'Covers hospitalization',
          'Includes outpatient treatment',
          'Optional dental and optical coverage',
        ],
        requirements: [
          'National ID and KRA Pin',
          'Medical history (if applicable)',
        ],
        image: '/assets/images/insurance/medical.jpg',
      },
      {
        id: 19,
        title: 'Domestic Package',
        description: 'Insurance for your home and contents.',
        details: 'Covers loss or damage from theft, burglary, fire, and related perils for residential buildings and household contents, whether owned or rented.',
        benefits: [
          'Covers theft and fire',
          'Protects household contents',
          'Suitable for renters and owners',
        ],
        requirements: [
          'Property ownership or lease documents',
          'National ID and KRA Pin',
        ],
        image: '/assets/images/insurance/domestic-package.jpg',
      },
      {
        id: 20,
        title: 'Marine Insurance',
        description: 'Coverage for goods and vessels in transit.',
        details: 'Compensates for loss or damage to goods and merchandise in transit by sea, air, rail, road, or registered post.',
        benefits: [
          'Covers multiple transport modes',
          'Protects against loss or damage',
          'Suitable for small and large operations',
        ],
        requirements: [
          'Transport or shipping documents',
          'Business registration documents',
          'National ID and KRA Pin',
        ],
        image: '/assets/images/insurance/marine.jpg',
      },
      {
        id: 21,
        title: 'Travel Insurance',
        description: 'Coverage for costs and losses while traveling.',
        details: 'Protects against costs and losses associated with domestic or international travel.',
        benefits: [
          'Covers travel-related losses',
          'Suitable for domestic and international travel',
          'Peace of mind for travelers',
        ],
        requirements: [
          'Travel itinerary',
          'National ID and KRA Pin',
        ],
        image: '/assets/images/insurance/travel.jpg',
      },
      {
        id: 22,
        title: "Golfer's Insurance",
        description: 'Tailored protection for golfers against course incidents.',
        details: 'Protects against accidents, equipment theft, or hole-in-one celebratory costs on the golf course or club premises.',
        benefits: [
          'Covers accidents and theft',
          'Includes hole-in-one celebration costs',
          'Peace of mind for golfers',
        ],
        requirements: [
          'Golf club membership (if applicable)',
          'National ID and KRA Pin',
        ],
        image: '/assets/images/insurance/golfers.jpg',
      },
    ],
  },
];

const TabIcon = ({ tab, isActive }) => {
  const color = isActive ? 'text-white' : 'text-primary-blue';
  switch (tab) {
    case 'All':
      return (
        <svg className={`w-5 h-5 mr-2 ${color}`} fill="currentColor" viewBox="0 0 24 24">
          <path d="M4 4h4v4H4V4zm6 0h4v4h-4V4zm6 0h4v4h-4V4zM4 10h4v4H4v-4zm6 0h4v4h-4v-4zm6 0h4v4h-4v-4zM4 16h4v4H4v-4zm6 0h4v4h-4v-4zm6 0h4v4h-4v-4z" />
        </svg>
      );
    case 'Loans':
      return (
        <svg className={`w-5 h-5 mr-2 ${color}`} fill="currentColor" viewBox="0 0 24 24">
          <path d="M21 10h-2.26A8.02 8.02 0 0012 3c-4.42 0-8 3.58-8 8s3.58 8 8 8c2.67 0 5.02-1.31 6.49-3.32H15v-2h6c.55 0 1 .45 1 1s-.45 1-1 1h-1.26C18.15 18.48 15.25 21 12 21c-5.52 0-10-4.48-10-10S6.48 1 12 1c3.86 0 7.24 2.18 8.94 5.39H21c.55 0 1 .45 1 1s-.45 1-1 1zm-9 5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
        </svg>
      );
    case 'Trade Finance':
      return (
        <svg className={`w-5 h-5 mr-2 ${color}`} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.79 9.29l-3.5 3.5c-.39.39-1.02.39-1.41 0l-1.5-1.5c-.39-.39-.39-1.02 0-1.41s1.02-.39 1.41 0l.79.79 2.79-2.79c.39-.39 1.02-.39 1.41 0s.39 1.02 0 1.41z" />
        </svg>
      );
    case 'Insurance Services':
      return (
        <svg className={`w-5 h-5 mr-2 ${color}`} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2L2 7v7c0 5.52 4.48 10 10 10s10-4.48 10-10V7L12 2zm0 18c-4.41 0-8-3.59-8-8V9.24L12 5l8 4.24V14c0 4.41-3.59 8-8 8z" />
        </svg>
      );
    default:
      return null;
  }
};

const IconArrow = ({ className }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
  </svg>
);

const ShareIcon = ({ platform, className }) => {
  switch (platform) {
    case 'twitter':
      return (
        <svg className={className} fill="currentColor" viewBox="0 0 24 24">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      );
    case 'facebook':
      return (
        <svg className={className} fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12a12 12 0 10-13.88 11.88v-8.4h-3.1V12h3.1V9.36c0-3.06 1.82-4.74 4.61-4.74 1.34 0 2.74.24 2.74.24v3.02h-1.54c-1.52 0-2 .91-2 1.84V12h3.48l-.46 3.48h-2.86v8.4A12 12 0 0024 12z" />
        </svg>
      );
    case 'linkedin':
      return (
        <svg className={className} fill="currentColor" viewBox="0 0 24 24">
          <path d="M19 3a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14zm-1.5 15.25V13.5a3.25 3.25 0 00-3.25-3.25h-.01a3.25 3.25 0 00-3.24 3.25v4.75h-3v-10h3v1.45a3.74 3.74 0 013.24-1.95h-.01a3.75 3.75 0 013.75 3.75v5h-3zm-10-13.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm1.5 13.5v-10h-3v10h3z" />
        </svg>
      );
    case 'instagram':
      return (
        <svg className={className} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2.16c3.2 0 3.58.01 4.84.07 1.26.06 1.94.27 2.39.45.6.24.98.52 1.41.95.43.43.71.81.95 1.41.18.45.39 1.13.45 2.39.06 1.26.07 1.64.07 4.84s-.01 3.58-.07 4.84c-.06 1.26-.27 1.94-.45 2.39-.24.6-.52.98-.95 1.41-.43.43-.81.71-1.41.95-.45.18-1.13.39-2.39.45-1.26.06-1.64.07-4.84.07s-3.58-.01-4.84-.07c-1.26-.06-1.94-.27-2.39-.45-.6-.24-.98-.52-1.41-.95-.43-.43-.71-.81-.95-1.41-.18-.45-.39-1.13-.45-2.39-.06-1.26-.07-1.64-.07-4.84s.01-3.58.07-4.84c.06-1.26.27-1.94.45-2.39.24-.6.52-.98.95-1.41.43-.43.81-.71 1.41-.95.45-.18 1.13-.39 2.39-.45 1.26-.06 1.64-.07 4.84-.07zm0 2.16c-3.14 0-5.68 2.54-5.68 5.68s2.54 5.68 5.68 5.68 5.68-2.54 5.68-5.68-2.54-5.68-5.68-5.68zm0 9.36c-2.06 0-3.68-1.62-3.68-3.68s1.62-3.68 3.68-3.68 3.68 1.62 3.68 3.68-1.62 3.68-3.68 3.68zm4.68-9.52c0 .74-.6 1.34-1.34 1.34s-1.34-.6-1.34-1.34.6-1.34 1.34-1.34 1.34.6 1.34 1.34z" />
        </svg>
      );
    default:
      return (
        <svg className={className} fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm6 12.5h-4.5v4.5h-3v-4.5H6v-3h4.5V6h3v5.5H18v3z" />
        </svg>
      );
  }
};

const Products = () => {
  const [isReadMoreModalOpen, setIsReadMoreModalOpen] = useState(false);
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [isShareOpen, setIsShareOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    address: '',
    phone: '',
    service: '',
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionError, setSubmissionError] = useState('');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [activeTab, setActiveTab] = useState('All');
  const [transform, setTransform] = useState({});
  const rafId = useRef(null);
  const cardRefs = useRef({});
  const formModalRef = useRef(null);

  const openReadMoreModal = (product) => {
    console.log('Opening read more modal for product:', product.title);
    setSelectedProduct({
      ...product,
      shareUrl: `https://tglcredit.com/products/${product.id}`,
    });
    setIsReadMoreModalOpen(true);
    setIsShareOpen(false);
  };

  const closeReadMoreModal = () => {
    setIsReadMoreModalOpen(false);
    setSelectedProduct({});
    setIsShareOpen(false);
  };

  const openFormModal = (title) => {
    console.log('Opening form modal for product:', title);
    if (!title) {
      console.error('No product title provided');
      setFormErrors({ service: 'Service is required' });
      return;
    }
    setFormData({
      name: '',
      email: '',
      address: '',
      phone: '',
      service: title, // Set service immediately
    });
    setSelectedProduct({ title }); // Keep selectedProduct minimal
    setIsFormModalOpen(true);
    setFormErrors({});
    setSubmissionError('');
    setShowSuccessMessage(false);
    closeReadMoreModal();
  };

  const closeFormModal = () => {
    setIsFormModalOpen(false);
    setSelectedProduct({});
    setFormData({ name: '', email: '', address: '', phone: '', service: '' });
    setFormErrors({});
    setSubmissionError('');
    setShowSuccessMessage(false);
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.name.trim() || formData.name.length < 2) {
      errors.name = 'Full name must be at least 2 characters';
    }
    if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = 'Please enter a valid email address';
    }
    if (!formData.address.trim() || formData.address.length < 5) {
      errors.address = 'Address must be at least 5 characters';
    }
    if (!formData.phone.trim() || !/^\+?\d{10,15}$/.test(formData.phone.replace(/\s/g, ''))) {
      errors.phone = 'Please enter a valid phone number (10-15 digits)';
    }
    if (!formData.service.trim()) {
      errors.service = 'Service is required';
    }
    return errors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: '' }));
    }
    if (submissionError) {
      setSubmissionError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      console.log('Form validation errors:', errors);
      return;
    }
    setIsSubmitting(true);
    try {
      const payload = {
        name: formData.name.trim(),
        email: formData.email.trim(),
        address: formData.address.trim(),
        phone: formData.phone.trim(),
        service: formData.service.trim(), // Use formData.service consistently
      };
      console.log('Sending payload:', payload);
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_URL || 'https://tglcredit.co.ke/api/product-email.php',
        payload,
        { headers: { 'Content-Type': 'application/json' } } // Ensure correct Content-Type
      );
      console.log('Email sent successfully:', response.data);
      setShowSuccessMessage(true);
      setFormErrors({});
      setTimeout(() => {
        closeFormModal();
      }, 3000);
    } catch (error) {
      console.error('Error sending email:', error);
      if (error.response) {
        setSubmissionError(`Failed to send application: ${error.response.data.message || error.message}`);
      } else if (error.request) {
        setSubmissionError('Failed to send application. Please check your connection or server availability.');
      } else {
        setSubmissionError('Failed to send application. An unexpected error occurred.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const toggleShare = () => {
    setIsShareOpen((prev) => !prev);
  };

  const handleShare = (platform) => {
    const { title, description, shareUrl } = selectedProduct;
    const text = `Check out ${title} at TGL Credit! ${description}`;
    let shareLink = '';

    switch (platform) {
      case 'twitter':
        shareLink = `https://x.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(shareUrl)}`;
        break;
      case 'facebook':
        shareLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
        break;
      case 'linkedin':
        shareLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(description)}`;
        break;
      case 'instagram':
        console.log(`Instagram share caption: ${text} ${shareUrl}`);
        alert('Instagram sharing is not supported directly. Copy the caption from the console and post manually on Instagram.');
        shareLink = 'https://www.instagram.com';
        break;
      default:
        return;
    }

    window.open(shareLink, '_blank', 'noopener,noreferrer');
    setIsShareOpen(false);
  };

  const handleMouseMove = useCallback((e, id) => {
    if (rafId.current) cancelAnimationFrame(rafId.current);
    rafId.current = requestAnimationFrame(() => {
      const card = cardRefs.current[id];
      if (!card) {
        console.warn(`Card element for ID ${id} is null in handleMouseMove`);
        return;
      }
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;
      const maxTilt = 5;
      const translateX = (x / rect.width) * 8;
      const translateY = (y / rect.height) * 8;
      const rotateX = (y / rect.height) * maxTilt;
      const rotateY = -(x / rect.width) * maxTilt;
      setTransform((prev) => ({
        ...prev,
        [id]: `translate3d(${translateX}px, ${translateY}px, 0) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`,
      }));
    });
  }, []);

  const handleMouseLeave = useCallback((id) => {
    if (rafId.current) cancelAnimationFrame(rafId.current);
    setTransform((prev) => ({
      ...prev,
      [id]: 'translate3d(0, 0, 0) rotateX(0deg) rotateY(0deg)',
    }));
  }, []);

  useEffect(() => {
    return () => {
      if (rafId.current) cancelAnimationFrame(rafId.current);
      Object.values(cardRefs.current).forEach((card) => {
        if (card) {
          card.removeEventListener('mousemove', handleMouseMove);
          card.removeEventListener('mouseleave', handleMouseLeave);
        }
      });
    };
  }, [handleMouseMove, handleMouseLeave]);

  // Focus trap for form modal
  useEffect(() => {
    if (isFormModalOpen && formModalRef.current) {
      const focusableElements = formModalRef.current.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      const handleKeyDown = (e) => {
        if (e.key === 'Tab') {
          if (e.shiftKey && document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
          } else if (!e.shiftKey && document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
          }
        } else if (e.key === 'Escape') {
          closeFormModal();
        }
      };

      document.addEventListener('keydown', handleKeyDown);
      firstElement.focus();

      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [isFormModalOpen]);

  const filteredProducts =
    activeTab === 'All'
      ? products.flatMap((category) => category.items)
      : products.find((category) => category.category === activeTab)?.items || [];

  return (
    <>
      <section className="bg-gradient-to-b from-gray-50 to-white py-16 sm:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl sm:text-3xl font-inter font-extrabold text-center mb-4 animate-fade-up">
            <span className="text-gray-800 relative group inline-block">
              Our
              <span className="absolute bottom-0 left-0 w-full h-0.5 bg-primary-red transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />
            </span>{' '}
            <span className="text-primary-blue">Products</span>
          </h2>
          <p className="text-sm font-inter font-normal text-gray-600 text-center mb-12 max-w-2xl mx-auto animate-fade-up" style={{ animationDelay: '0.2s' }}>
            Discover our tailored financial solutions, from loans and insurance to trade support, designed to empower your goals.
          </p>
          {/* Tabs */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-8 border-b border-gray-200">
            {['All', 'Loans', 'Trade Finance', 'Insurance Services'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`flex items-center px-4 py-2 text-sm font-inter font-medium transition-all duration-300 ${
                  activeTab === tab
                    ? 'bg-primary-blue text-white'
                    : 'text-gray-600 hover:text-primary-red hover:bg-gray-100'
                } rounded-t-md`}
                aria-selected={activeTab === tab}
                role="tab"
                aria-label={`View ${tab} products`}
              >
                <TabIcon tab={tab} isActive={activeTab === tab} />
                {tab}
                {activeTab === tab && (
                  <span className="absolute bottom-0 left-0 w-full h-1 bg-primary-red"></span>
                )}
              </button>
            ))}
          </div>
          {/* Product Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {filteredProducts.map((product, index) => (
              <div
                key={product.id}
                className="relative bg-white rounded-lg shadow-md hover:shadow-lg border border-primary-blue/10 transition-all duration-300 cursor-pointer hover:-translate-y-1 animate-fade-up"
                ref={(el) => (cardRefs.current[product.id] = el)}
                onMouseMove={(e) => handleMouseMove(e, product.id)}
                onMouseLeave={() => handleMouseLeave(product.id)}
                style={{ animationDelay: `${0.4 + index * 0.2}s`, willChange: 'transform, box-shadow' }}
              >
                <div className="relative overflow-hidden rounded-t-lg group">
                  <div
                    className="absolute inset-0 bg-gradient-to-t from-primary-blue/20 to-transparent opacity-0 group-hover:opacity-50 transition-opacity duration-500 ease-in-out z-10"
                    style={{ willChange: 'opacity' }}
                  ></div>
                  <div className="absolute top-3 left-3 z-20">
                    <span
                      className={`text-sm font-inter font-semibold text-${index % 2 === 0 ? 'primary-blue' : 'primary-red'} bg-white/80 rounded-md px-3 py-1.5 drop-shadow-sm tracking-tight`}
                    >
                      {product.title}
                    </span>
                  </div>
                  <img
                    src={product.image}
                    alt={product.title}
                    className="w-full h-64 object-cover rounded-t-lg transform transition-all duration-500 ease-in-out group-hover:scale-105 group-hover:brightness-105"
                    style={{
                      transform: transform[product.id] || 'translate3d(0, 0, 0) rotateX(0deg) rotateY(0deg)',
                      transformStyle: 'preserve-3d',
                      willChange: 'transform, filter',
                      aspectRatio: '3 / 2',
                    }}
                    loading="lazy"
                    onError={(e) => {
                      e.target.src = '/assets/images/fallback.jpg';
                      console.error(`Failed to load image: ${product.image}`);
                    }}
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-inter font-bold text-primary-blue mb-3 tracking-tight">{product.title}</h3>
                  <p className="text-sm font-inter font-normal text-gray-600 mb-4">{product.description}</p>
                  <button
                    onClick={() => openReadMoreModal(product)}
                    className="group w-full bg-primary-blue text-white font-medium px-4 py-2 rounded-md hover:bg-primary-red transition-all duration-300 hover:shadow-lg hover:shadow-primary-red/30 focus:ring-2 focus:ring-primary-blue focus:ring-offset-2 flex items-center justify-center"
                    style={{ willChange: 'background-color, box-shadow' }}
                    aria-label={`Read more about ${product.title}`}
                  >
                    <span className="flex items-center text-sm uppercase tracking-wide">
                      Read More
                      <span className="ml-2 rounded-full bg-transparent border border-white group-hover:border-white p-1 flex items-center justify-center">
                        <IconArrow className="w-3 h-3 group-hover:translate-x-1 transition-transform duration-300 text-white" />
                      </span>
                    </span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Read More Modal */}
      {isReadMoreModalOpen && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 animate-slide-in-left" role="dialog" aria-modal="true">
          <div className="bg-white/95 backdrop-blur-md rounded-lg w-full max-w-4xl mx-4 p-8 shadow-2xl border border-gray-200 overflow-hidden">
            <div className="flex flex-col md:flex-row">
              <div className="w-full md:w-1/2 relative">
                <img
                  src={selectedProduct.image}
                  alt={selectedProduct.title}
                  className="w-full h-48 md:h-full object-cover rounded-lg"
                  style={{ aspectRatio: '4 / 3' }}
                  loading="lazy"
                  onError={(e) => {
                    e.target.src = '/assets/images/fallback.jpg';
                    console.error(`Failed to load image: ${selectedProduct.image}`);
                  }}
                />
                <div className="absolute inset-0 bg-primary-blue/10 rounded-lg"></div>
              </div>
              <div className="w-full md:w-1/2 p-6 flex flex-col justify-between overflow-y-auto max-h-[70vh]">
                <div>
                  <div className="flex justify-between items-center mb-4 sticky top-0 bg-white z-10">
                    <h3 className="text-base font-inter font-bold text-primary-blue">{selectedProduct.title}</h3>
                    <button
                      onClick={closeReadMoreModal}
                      className="text-primary-blue hover:text-primary-red focus:ring-2 focus:ring-primary-red focus:ring-offset-2 rounded-full p-1"
                      aria-label="Close read more modal"
                    >
                      <FaTimes className="w-6 h-6" />
                    </button>
                  </div>
                  <hr className="border-primary-red mb-4" />
                  {selectedProduct.details && (
                    <p className="text-sm font-inter font-normal text-gray-600 leading-relaxed mb-4">{selectedProduct.details}</p>
                  )}
                  {selectedProduct.benefits && Array.isArray(selectedProduct.benefits) && (
                    <div className="mb-4">
                      <h4 className="text-sm font-inter font-semibold text-primary-blue mb-1">Benefits</h4>
                      <ul className="list-disc pl-4 text-xs font-inter font-normal text-gray-600">
                        {selectedProduct.benefits.map((benefit, index) => (
                          <li key={index}>{benefit}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {selectedProduct.requirements && Array.isArray(selectedProduct.requirements) && (
                    <div className="mb-4">
                      <h4 className="text-sm font-inter font-semibold text-primary-blue mb-1">Requirements</h4>
                      <ul className="list-disc pl-4 text-xs font-inter font-normal text-gray-600">
                        {selectedProduct.requirements.map((requirement, index) => (
                          <li key={index}>{requirement}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  <hr className="border-gray-200 my-4" />
                  <div className="relative">
                    <button
                      onClick={toggleShare}
                      className="flex items-center text-sm font-inter font-medium text-primary-blue hover:text-primary-red transition-all duration-300 focus:ring-2 focus:ring-primary-blue focus:ring-offset-2"
                      aria-label={`Share ${selectedProduct.title}`}
                      aria-expanded={isShareOpen}
                    >
                      <ShareIcon platform="share" className="w-3.5 h-3.5 mr-1" />
                      Share
                    </button>
                    {isShareOpen && (
                      <div className="absolute left-0 mt-2 flex space-x-2 bg-white border border-gray-200 rounded-md shadow-lg p-2 z-20 animate-fade-in">
                        <button
                          onClick={() => handleShare('twitter')}
                          className="p-1 text-primary-blue hover:text-primary-red hover:scale-110 transition-all duration-300 focus:ring-2 focus:ring-primary-blue focus:ring-offset-1"
                          aria-label={`Share ${selectedProduct.title} on Twitter/X`}
                        >
                          <ShareIcon platform="twitter" className="w-4 h-4" />
                        </button>
                        <button
                          onClick={() => handleShare('facebook')}
                          className="p-1 text-primary-blue hover:text-primary-red hover:scale-110 transition-all duration-300 focus:ring-2 focus:ring-primary-blue focus:ring-offset-1"
                          aria-label={`Share ${selectedProduct.title} on Facebook`}
                        >
                          <ShareIcon platform="facebook" className="w-4 h-4" />
                        </button>
                        <button
                          onClick={() => handleShare('linkedin')}
                          className="p-1 text-primary-blue hover:text-primary-red hover:scale-110 transition-all duration-300 focus:ring-2 focus:ring-primary-blue focus:ring-offset-1"
                          aria-label={`Share ${selectedProduct.title} on LinkedIn`}
                        >
                          <ShareIcon platform="linkedin" className="w-4 h-4" />
                        </button>
                        <button
                          onClick={() => handleShare('instagram')}
                          className="p-1 text-primary-blue hover:text-primary-red hover:scale-110 transition-all duration-300 focus:ring-2 focus:ring-primary-blue focus:ring-offset-1"
                          aria-label={`Share ${selectedProduct.title} on Instagram`}
                        >
                          <ShareIcon platform="instagram" className="w-4 h-4" />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex justify-end mt-4">
                  <button
                    onClick={() => openFormModal(selectedProduct.title)}
                    className="group bg-primary-blue text-white font-medium px-6 py-2 rounded-md hover:bg-primary-red hover:shadow-lg hover:shadow-primary-red/30 transition-all duration-300 focus:ring-2 focus:ring-primary-blue focus:ring-offset-2 flex items-center text-sm uppercase tracking-wide"
                    aria-label={`Apply for ${selectedProduct.title}`}
                  >
                    <span className="flex items-center">
                      Apply Now
                      <span className="ml-2 rounded-full bg-transparent border border-white group-hover:border-white p-1 flex items-center justify-center">
                        <IconArrow className="w-3 h-3 group-hover:translate-x-1 transition-transform duration-300 text-white" />
                      </span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Form Modal */}
      {isFormModalOpen && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 animate-slide-in-left" role="dialog" aria-modal="true">
          <div
            ref={formModalRef}
            className="bg-white/95 backdrop-blur-md rounded-lg w-full max-w-sm sm:w-80 absolute right-0 top-0 h-full sm:h-auto sm:max-h-[calc(100vh-2rem)] overflow-y-auto p-8 sm:p-6 shadow-2xl border border-gray-200"
            style={{ boxShadow: '0 4px 12px rgba(47, 73, 140, 0.3), 0 2px 8px rgba(132, 51, 69, 0.2)' }}
          >
            <div className="relative mb-6">
              <h3 className="text-lg sm:text-xl font-inter font-bold text-primary-blue tracking-tight text-center">
                Application Form
              </h3>
              <hr className="mt-2 mb-4 border-t-2 border-primary-blue w-1/2 mx-auto" />
              <button
                onClick={closeFormModal}
                className="absolute top-0 right-0 text-primary-blue hover:text-primary-red focus:ring-2 focus:ring-primary-red focus:ring-offset-2 rounded-full"
                aria-label="Close application form modal"
              >
                <FaTimes className="w-5 h-5 sm:w-6 sm:h-6" />
              </button>
            </div>
            {showSuccessMessage ? (
              <div
                className="bg-green-100 text-green-800 p-3 sm:p-4 rounded-lg mb-4 animate-fade-in"
                role="alert"
                aria-live="polite"
              >
                <h4 className="text-sm sm:text-base font-inter font-semibold text-green-800">
                  Application Sent Successfully!
                </h4>
                <p className="text-xs sm:text-sm font-inter text-green-700">
                  Thank you for your application. We’ll respond within 2 hours.
                </p>
              </div>
            ) : (
              <>
                {submissionError && (
                  <div
                    className="bg-red-100 text-red-800 p-2 sm:p-3 rounded-lg mb-4 animate-fade-in"
                    role="alert"
                    aria-live="polite"
                  >
                    <p className="text-xs sm:text-sm">{submissionError}</p>
                  </div>
                )}
                {!submissionError && (
                  <p className="text-xs sm:text-sm font-inter font-medium text-gray-600 mb-4 sm:mb-6 text-center">
                    Our team will respond within 2 hours.
                  </p>
                )}
                <form onSubmit={handleSubmit} noValidate className="space-y-3 sm:space-y-4">
                  <div>
                    <label htmlFor="name" className="block text-xs sm:text-sm font-inter font-medium text-primary-blue mb-1">
                      Full Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className={`w-full px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm border ${
                        formErrors.name ? 'border-primary-red' : 'border-primary-blue/30'
                      } rounded-md focus:outline-none focus:border-primary-blue focus:ring-1 focus:ring-primary-blue/50`}
                      placeholder="Enter your full name"
                      required
                      aria-required="true"
                      aria-describedby={formErrors.name ? 'name-error' : undefined}
                    />
                    {formErrors.name && (
                      <p id="name-error" className="text-primary-red text-[10px] sm:text-xs mt-1" role="alert">
                        {formErrors.name}
                      </p>
                    )}
                  </div>
                  <div>
                    <label htmlFor="service" className="block text-xs sm:text-sm font-inter font-medium text-primary-blue mb-1">
                      Service Requested
                    </label>
                    <input
                      type="text"
                      id="service"
                      name="service"
                      value={formData.service}
                      readOnly
                      className={`w-full px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm border ${
                        formErrors.service ? 'border-primary-red' : 'border-primary-blue/30'
                      } rounded-md font-medium text-primary-blue bg-gray-50`}
                      aria-describedby={formErrors.service ? 'service-error' : undefined}
                    />
                    {formErrors.service && (
                      <p id="service-error" className="text-primary-red text-[10px] sm:text-xs mt-1" role="alert">
                        {formErrors.service}
                      </p>
                    )}
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-xs sm:text-sm font-inter font-medium text-primary-blue mb-1">
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className={`w-full px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm border ${
                        formErrors.email ? 'border-primary-red' : 'border-primary-blue/30'
                      } rounded-md focus:outline-none focus:border-primary-blue focus:ring-1 focus:ring-primary-blue/50`}
                      placeholder="Enter your email address"
                      required
                      aria-required="true"
                      aria-describedby={formErrors.email ? 'email-error' : undefined}
                    />
                    {formErrors.email && (
                      <p id="email-error" className="text-primary-red text-[10px] sm:text-xs mt-1" role="alert">
                        {formErrors.email}
                      </p>
                    )}
                  </div>
                  <div>
                    <label htmlFor="address" className="block text-xs sm:text-sm font-inter font-medium text-primary-blue mb-1">
                      Address
                    </label>
                    <input
                      type="text"
                      id="address"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      className={`w-full px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm border ${
                        formErrors.address ? 'border-primary-red' : 'border-primary-blue/30'
                      } rounded-md focus:outline-none focus:border-primary-blue focus:ring-1 focus:ring-primary-blue/50`}
                      placeholder="Enter your address"
                      required
                      aria-required="true"
                      aria-describedby={formErrors.address ? 'address-error' : undefined}
                    />
                    {formErrors.address && (
                      <p id="address-error" className="text-primary-red text-[10px] sm:text-xs mt-1" role="alert">
                        {formErrors.address}
                      </p>
                    )}
                  </div>
                  <div>
                    <label htmlFor="phone" className="block text-xs sm:text-sm font-inter font-medium text-primary-blue mb-1">
                      Phone
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className={`w-full px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm border ${
                        formErrors.phone ? 'border-primary-red' : 'border-primary-blue/30'
                      } rounded-md focus:outline-none focus:border-primary-blue focus:ring-1 focus:ring-primary-blue/50`}
                      placeholder="Enter your phone number (e.g., +254123456789)"
                      required
                      aria-required="true"
                      aria-describedby={formErrors.phone ? 'phone-error' : undefined}
                    />
                    {formErrors.phone && (
                      <p id="phone-error" className="text-primary-red text-[10px] sm:text-xs mt-1" role="alert">
                        {formErrors.phone}
                      </p>
                    )}
                  </div>
                  <div className="flex justify-end gap-2 mt-4 sm:mt-6">
                    <button
                      type="button"
                      onClick={closeFormModal}
                      className="bg-gray-200 text-primary-blue font-medium px-3 sm:px-4 py-1.5 sm:py-2 rounded-md hover:bg-gray-300 hover:text-primary-red transition-all duration-300 uppercase tracking-wide text-xs sm:text-sm focus:ring-2 focus:ring-primary-blue focus:ring-offset-2"
                      disabled={isSubmitting}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="group bg-primary-blue text-white font-medium px-3 sm:px-4 py-1.5 sm:py-2 rounded-md hover:bg-primary-red hover:shadow-lg hover:shadow-primary-red/30 transition-all duration-300 uppercase tracking-wide text-xs sm:text-sm focus:ring-2 focus:ring-primary-blue focus:ring-offset-2 flex items-center gap-2"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <>
                          <svg
                            className="animate-spin h-4 w-4 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                          Submitting...
                        </>
                      ) : (
                        <>
                          Submit
                          <span className="ml-2 rounded-full bg-transparent border border-white group-hover:border-white p-1 flex items-center justify-center">
                            <IconArrow className="w-3 h-3 group-hover:translate-x-1 transition-transform duration-300 text-white" />
                          </span>
                        </>
                      )}
                    </button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      )}

      <style>
        {`
          :root {
            --primary-blue: #2F498C;
            --primary-red: #843345;
          }
          @keyframes fade-up {
            from { opacity: 0; transform: translateY(15px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-fade-up {
            animation: fade-up 0.8s ease-in-out forwards;
            willChange: transform, opacity;
          }
          @keyframes fade-in {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          .animate-fade-in {
            animation: fade-in 0.8s ease-in-out forwards;
            willChange: opacity;
          }
          @keyframes slide-in-left {
            from { opacity: 0; transform: translateX(-100%); }
            to { opacity: 1; transform: translateX(0); }
          }
          .animate-slide-in-left {
            animation: slide-in-left 0.3s ease-out forwards;
            willChange: transform, opacity;
          }
          .backdrop-blur-sm {
            backdrop-filter: blur(4px);
            -webkit-backdrop-filter: blur(4px);
          }
          .backdrop-blur-md {
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px);
          }
          @media (max-width: 639px) {
            .max-w-sm {
              max-width: none;
              width: 100%;
            }
            .sm\\:w-80 {
              width: 100%;
            }
            .sm\\:p-6 {
              padding: 1rem;
            }
            .sm\\:h-auto {
              height: 100%;
            }
            .sm\\:max-h-\\[calc\\(100vh-2rem\\)\\] {
              max-height: calc(100vh - 1rem);
            }
            .sm\\:text-sm {
              font-size: 0.75rem; /* 12px for mobile */
            }
            .sm\\:text-base {
              font-size: 0.875rem; /* 14px for mobile */
            }
            .sm\\:p-4 {
              padding: 0.75rem;
            }
            .sm\\:p-3 {
              padding: 0.5rem;
            }
            .sm\\:mt-6 {
              margin-top: 1rem;
            }
            .sm\\:mb-6 {
              margin-bottom: 1rem;
            }
            .sm\\:px-4 {
              padding-left: 0.75rem;
              padding-right: 0.75rem;
            }
            .sm\\:py-2 {
              padding-top: 0.5rem;
              padding-bottom: 0.5rem;
            }
            .sm\\:min-h-\\[100px\\] {
              min-height: 80px;
            }
            .sm\\:w-6 {
              width: 1.25rem;
            }
            .sm\\:h-6 {
              height: 1.25rem;
            }
            .sm\\:space-y-4 {
              gap: 0.75rem;
            }
          }
          @media (prefers-reduced-motion: reduce) {
            .animate-fade-up, .animate-fade-in, .animate-slide-in-left, .group-hover\\:scale-105, .group-hover\\:brightness-105, .group-hover\\:opacity-50, .group-hover\\:translate-x-1, .hover\\:shadow-lg, .hover\\:-translate-y-1, .hover\\:scale-110 {
              animation: none !important;
              transform: none !important;
              opacity: 1 !important;
              transition: none !important;
            }
          }
        `}
      </style>
    </>
  );
};

export default Products;